export class ScheduledAction {
  constructor(name, delay) {
    this.name = name
    this.delay = delay
  }
}
